var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('membership-about-to-end'),_c('payment'),_c('service'),_c('order-notes-manager'),_c('category'),_c('order-payment'),_c('expense'),_c('account-compliance-reward',{attrs:{"show":_vm.showComplianceReward},on:{"close":function($event){_vm.showComplianceReward = false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }